<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal" id="NewReturnPartnersModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('common.addition') }}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll-x" ref="xscroll">
            <table class="table table-striped table-align-top table-1200 no-margin-bottom font-size-smaller">
              <thead>
                <tr>
                  <th class="unlimited_no_th">No.</th>
                  <th>{{ translations('return_partner.verification_results') }}</th>
                  <th>{{ translations('return_partner.product_condition') }}</th>
                  <th>{{ translations('return_partner.warehouse') }}</th>
                  <th>JAN / ITEM# / {{ translations('return_partner.model_number') }} / {{ translations('return_partner.quantity') }}</th>
                  <th>{{ translations('return_partner.number_item') }}</th>
                  <th>{{ translations('return_partner.unit_price') }}</th>
                  <th>{{ translations('return_partner.summary') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
              <tr v-for="(tempDetail, i) in tempDetails" :key="i">
                <td class="unlimited_no_td">
                  {{i+1}}
                </td>
                <td>
                  <input v-model="tempDetail.test_result" class="form-control form-control-sm min-width-80 min-height-35" type="text">
                </td>
                <td>
                  <select v-model="tempDetail.type_product_id" @change="getProducts(i)" class="custom-select keep-select">
                    <option  v-for="(type, index) in translatedTypeProduct" :key="index" :value="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </td>
                <td>
                  <v-select :filter="searchWarehouse" @input="selectWarehouse(i)" v-model="selectedWarehouse[i]" :options="warehouses" label="name" value="id"></v-select>
                </td>
                <td>
                  <v-select :filter="searchProduct" @input="selectProduct(i)" v-model="selectedProduct[i]" :options="tempDetail.productList" label="label" value="id"></v-select>
                </td>
                <td>
                  <input v-on:keyup="quantityKeyUp($event, tempDetail, i)" v-model="tempDetail.quantity" class="form-control form-control-sm min-width-60 min-height-35 input-right" type="text">
                  <small v-if="quantityWarnings[i]" class="text-danger">{{ quantityWarnings[i] }}</small>
                </td>
                <td>
                  <input v-model="tempDetail.unit_price"
                         class="form-control form-control-sm min-width-80 min-height-35 input-right"
                         type="text">
                </td>
                <td>
                  <input v-model="tempDetail.remarks" class="form-control form-control-sm min-width-60 min-height-35" type="text">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div>
            <button type="button" class="btn btn-info" @click="addRows(10)">{{ translations('return.add_row') }}</button>
          </div>
          <div>
            <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
            <button type="button" class="btn btn-primary margin-left-10" @click="updateDetails()">{{ translations('common.update') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'NewReturnPartnersModal',
  components: {
    VueElementLoading
  },
  props: {
    vat: {}, // VAT
    returnDetails: {},
    returnWarehouses: {},
    partnerId: {},
    arrivedDate: {}
  },
  data () {
    return {
      rows: 10,
      return_products: [],
      tempDetails: [],
      testData: [],
      isLoading: false,
      warehouses: [],
      productList: [],
      searchReasons: {},
      searchProducts: {},
      searchWarehouses: {},
      selectedReason: [],
      selectedProduct: [],
      selectedWarehouse: [],
      selectedTypeProduct: [],
      quantityWarnings: []
    }
  },
  created () {
    this.emptyDetail()
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.changeLoadingStatus)
  },
  computed: {
    ...mapState(['currentLanguage']),
    translatedTypeProduct () {
      const typeProduct = [
        { id: 0, name: 'return_partner.good' },
        { id: 1, name: 'return_partner.bad' },
        { id: 2, name: 'return_partner.outlet' }
      ]
      return typeProduct.map(type => ({
        ...type,
        name: this.translations(type.name)
      }))
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, tempDetail, index) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      const selectedProduct = this.selectedProduct[index]
      if (value > Number(selectedProduct.quantity)) {
        this.$set(this.quantityWarnings, index, this.translations('return_partner.warning_quantity_exceed_stock') + selectedProduct.quantity)
        value = selectedProduct.quantity
      } else {
        this.$set(this.quantityWarnings, index, '')
      }

      tempDetail.quantity = value
    },
    emptyDetail () {
      this.rows = 10
      this.tempDetails = []
      this.selectedReason = []
      this.selectedProduct = []
      this.selectedWarehouse = []
      this.selectedTypeProduct = []
      for (let i = 0; i < this.rows; i++) {
        this.tempDetails.push({
          taxclass_id: '1', // TAXSTATUS
          unit_price: '',
          quantity: '',
          remarks: '',
          type_product_id: 0,
          test_result: '',
          product_id: '',
          from_warehouse: {
            id: 0,
            name: ''
          }
        })
        this.selectedReason.push('')
        this.selectedProduct.push('')
        this.selectedWarehouse.push('')
        this.selectedTypeProduct.push('')
      }
    },
    addRows (rows) {
      if (!rows) return
      for (let i = 0; i < rows; i++) {
        this.tempDetails.push({
          taxclass_id: '1', // TAXSTATUS
          unit_price: '',
          quantity: '',
          remarks: '',
          type_product_id: 0,
          test_result: '',
          product_id: ''
        })
        this.selectedReason.push('')
        this.selectedProduct.push('')
        this.selectedWarehouse.push('')
        this.selectedTypeProduct.push('')
        this.rows++ // ADD
      }
    },
    changeLoadingStatus () {
      this.isLoading = false
      let $this = this
      this.warehouses = []
      this.searchProducts = {}
      this.searchReasons = {}
      this.searchWarehouses = {}
      this.$props.returnWarehouses.forEach(function (warehouse) {
        $this.warehouses.push(warehouse)
        $this.searchWarehouses[warehouse.id] = warehouse
      })
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
    async getProducts (i) {
      try {
        this.isLoading = true
        const tempDetail = this.tempDetails[i]

        if (!tempDetail.warehouse || tempDetail.type_product_id == null) {
          this.isLoading = false
          return
        }

        let params = {}
        params = {
          partner_id: this.partnerId.id,
          warehouse_id: tempDetail.warehouse,
          condition: tempDetail.type_product_id,
          arrived_at: this.arrivedDate
        }

        let products = await this.$http.post(this.$api_url.return_partner_product_list, params)
        let $data = this.$invoiceTools.prepareResult(products.data, 'list', 'NewReturnPartner:getProducts')
        if ($data.success === true) {
          tempDetail.productList = []
          const products = $data.data
          products.forEach(function (product) {
            product.label = product.jan_code + ' / ' + product.item_no + ' / ' + product.model + ' / ' + product.quantity
            product.search = product.jan_code + ' / ' + product.item_no + ' / ' + product.model + ' / ' + product.description + ' / ' + product.legacy_code + ' / ' + product.quantity
            tempDetail.productList.push(product)
            this.searchProducts[product.id] = product
          }, this)
          this.isLoading = false
        } else {
          this.isLoading = false
          this.$toastr.error($data.data, this.translations('return_partner.processing_failed'))
        }
      } catch (error) {
        console.log('NewReturnPartner:getProducts:catch(error): ', error)
        this.$toastr.error(this.translations('return_partner.notice_failed'), this.translations('common.error'))
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    async updateDetails () {
      console.log(JSON.stringify(this.tempDetails)) // DEBUG

      const _async = async () => {
        let isError = false
        let newReturnDetail = []
        for (let i = 0; i < this.rows; i++) {
          if (this.tempDetails[i] && this.tempDetails[i].product_id) {
            const product = this.tempDetails[i]

            console.log(product)

            if (product.unit_price === '' || !product.quantity) {
              this.$toastr.warning(1 + i + this.translations('return_partner.notice_enter_required_data_line'), this.translations('common.warning'))
              isError = true
              return // BREAK
            } else if (isNaN(this.tempDetails[i].unit_price) || isNaN(this.tempDetails[i].quantity)) {
              this.$toastr.warning(1 + i + this.translations('return_partner.notice_enter_valid_number_line'), this.translations('common.warning'))
              isError = true
              return // BREAK
            }

            if (this.vat.taxIncluded) {
              product.unit_price_inctax = product.unit_price
              product.unit_price = this.$util.getExcludeTax(product.unit_price_inctax, this.vat.vatRate)
            } else {
              product.unit_price_inctax = this.$util.getIncludeTax(product.unit_price, this.vat.vatRate)
            }

            for (let i = 0; i < product.quantity; i++) {
              const data = JSON.parse(JSON.stringify(product))
              data.quantity = 1
              newReturnDetail.push(data)
            }
          }
        }
        this.$props.returnDetails.push(...newReturnDetail)
        if (!isError) {
          this.emptyDetail()
          this.$refs.closeModal.click()
        }
      }
      _async() // ASYNC await INSIDE
    },
    searchProduct (options, search) {
      return options.filter(option => {
        return option.search.indexOf(search) >= 0
      })
    },
    searchWarehouse (options, search) {
      return options.filter(option => {
        return option.name.indexOf(search) >= 0
      })
    },
    selectProduct (i) {
      const v = this.selectedProduct
      if (this.searchProducts[v[i].id]) {
        const product = this.searchProducts[v[i].id]
        this.tempDetails[i].product_id = product.id
        this.tempDetails[i].item_no = product.item_no
        this.tempDetails[i].jan_code = product.jan_code
        this.tempDetails[i].model = product.model
        this.tempDetails[i].unit_price = product.unit_price
        this.tempDetails[i].row_price = product.row_price
        this.tempDetails[i].unit_price_inctax = product.unit_price_inctax
        this.tempDetails[i].taxclass_id = product.taxclass_id
        this.tempDetails[i].tax_status = product.tax_status
        this.tempDetails[i].tax_included = product.tax_included
        this.tempDetails[i].tax_rate = product.tax_rate

        if (!this.tempDetails[i].unit_price || this.tempDetails[i].unit_price === '') {
          this.$set(this.tempDetails[i], 'unit_price', product.row_price)
        }
      }
    },
    selectWarehouse (i) {
      const v = this.selectedWarehouse
      if (this.searchWarehouses[v[i].id]) {
        const warehouse = this.searchWarehouses[v[i].id]
        this.tempDetails[i].warehouse = warehouse

        const typeProductId = this.tempDetails[i].type_product_id
        if (typeProductId || typeProductId === 0) {
          this.getProducts(i)
        }
      }
    }
  }
}
</script>
